import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Form, FormGroup, Modal } from "react-bootstrap";
import { CheckLg, Star } from "react-bootstrap-icons";
import { addQuickAccess, setErrorDialog, translateError } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

const ModalAddQuickAccess = (props) => {
    const dispatch= useDispatch();
    const { popData, setPopData } = props;
    const [error, setError] = useState(null);
    const { show, accessTitle, pageUrl, subSystem, icon, setQAList } = popData;
    let title = accessTitle;
    function close() {
        setError(null);
        setPopData({
            show: false
        })
    }
    function onSuccess(res)
    {
        setError(null);
        if(res.Data)
        {
            setQAList(res);
            setPopData({
                show:false
            })
        }
        if(res.Error)
        {
            setError(translateError(res.Error));
        }
    }
    function add(){
        if(title === "")
        {
            return;
        }
        const data = {
            PageUrl: pageUrl,
            Title: title,
            SubSystemName: subSystem,
            Icon: (new XMLSerializer()).serializeToString(icon)
          };
          addQuickAccess(data, onSuccess);
    }
    useEffect(()=>{

    },[show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span><Star size={18}/>&nbsp; افزودن به دسترسی سریع</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <FormGroup>
                <Form.Control defaultValue={accessTitle} onChange={(e)=>title = e.target.value}/>
                </FormGroup>
                {error && <div className="errors">{error}</div>}
                <Button variant="success" className="group-Btn mt-1" onClick={add}><CheckLg/>&nbsp;ثبت دسترسی</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddQuickAccess;